import { motion } from 'framer-motion';
import { Home } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';

const livingSituationOptions = [
  { value: 'rent', label: 'Rent' },
  { value: 'own', label: 'Own' },
  { value: 'board', label: 'Board' },
  { value: 'parents', label: 'Parents' },
  { value: 'other', label: 'Other' },
];

const StepAddress = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <div className="w-14 h-14 bg-[#00D47E]/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Home className="w-7 h-7 text-[#00D47E]" />
        </div>
        <h2 className="font-outfit text-2xl md:text-3xl font-bold text-black mb-2">
          Where Do You Live?
        </h2>
        <p className="text-gray-600">Your current living situation</p>
      </div>

      <div className="space-y-4">
        <div>
          <Label className="text-gray-700">Current Address</Label>
          <Input
            value={formData.address}
            onChange={(e) => handleChange('address', e.target.value)}
            placeholder="123 Main Street, Auckland"
            className="mt-2"
            data-testid="address-input"
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label className="text-gray-700">Years at Address</Label>
            <Input
              type="number"
              value={formData.address_duration_years}
              onChange={(e) => handleChange('address_duration_years', e.target.value)}
              placeholder="2"
              className="mt-2"
              data-testid="address-years-input"
            />
          </div>
          <div>
            <Label className="text-gray-700">Months</Label>
            <Input
              type="number"
              value={formData.address_duration_months}
              onChange={(e) => handleChange('address_duration_months', e.target.value)}
              placeholder="6"
              className="mt-2"
              data-testid="address-months-input"
            />
          </div>
        </div>

        <div>
          <Label className="text-gray-700 mb-3 block">Living Situation</Label>
          <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
            {livingSituationOptions.map(({ value, label }) => (
              <button
                key={value}
                onClick={() => handleChange('living_situation', value)}
                data-testid={`living-situation-${value}`}
                className={`p-3 rounded-lg border-2 text-sm font-medium transition-all ${
                  formData.living_situation === value
                    ? 'border-[#00D47E] bg-[#00D47E]/5 text-[#00D47E]'
                    : 'border-gray-200 hover:border-gray-300 text-gray-600'
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        {(formData.living_situation === 'rent' || formData.living_situation === 'own') && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="grid grid-cols-2 gap-4 pt-2"
          >
            <div>
              <Label className="text-gray-700">
                {formData.living_situation === 'rent' ? 'Rent' : 'Mortgage'} Amount
              </Label>
              <div className="mt-2 relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
                <Input
                  type="number"
                  value={formData.rent_mortgage_amount}
                  onChange={(e) => handleChange('rent_mortgage_amount', e.target.value)}
                  className="pl-7"
                  placeholder="500"
                  data-testid="housing-cost-input"
                />
              </div>
            </div>
            <div>
              <Label className="text-gray-700">Frequency</Label>
              <Select
                value={formData.rent_mortgage_frequency}
                onValueChange={(value) => handleChange('rent_mortgage_frequency', value)}
              >
                <SelectTrigger className="mt-2" data-testid="housing-frequency-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="weekly">Weekly</SelectItem>
                  <SelectItem value="fortnightly">Fortnightly</SelectItem>
                  <SelectItem value="monthly">Monthly</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default StepAddress;
